<template>
	<div class="container modularThree">
		<div
			class="part"
			:style="{
				'padding': showTitle == 1 ? '25px 0' : ''
			}"
		>
			<div
				v-if="showTitle == 1 "
				class="title"
			>
				<span class="span">{{title}}</span>
				<div v-if="isMore !== '0' " class="more" @click="goBanner">
					{{$t('index.3-txt2')}}
					<i class="el-icon-arrow-right"></i>
				</div>
			</div>
			<img
				v-if="bannerImg"
				class="bannerImg"
				:style="{
					'cursor': relevance_id ? 'pointer' : ''
				}"
				:src="bannerImg"
				@click="relevance_id && goBanner()"
				style="display: none;"
			>
			<div
				class="box-Goods_Item-01"
				:style="{
					'margin-top': ! goodsData.length ? '0' : ''
				}"
			>
				<el-carousel
					arrow="always" :autoplay="false" indicator-position="none" :loop="false"
					:initial-index="page > 0 ? page - 1 : 0"
					@change="hdlCarousel_Change"
				>
					<el-carousel-item
						v-for="(goodsData_Page, i_Page) of goodsData_Processed" :key="i_Page"
						 class="goods_Item-01_Page"
					>
						<template slot="prev"><span class="prev"><i class="el-icon-arrow-left"></i></span></template>
						<div
							v-for="(item,index) of goodsData_Page" :key="index"
							class="goods_Item-01"
						>
							<div
								v-if="Number(item.item_price) / Number(item.item_original_price) < 1"
								class="goods_Tag-Price"
							>
								{{
									(Number(item.item_price) / Number(item.item_original_price) * 10).toFixed(1)
								}}折
							</div>
							<img class="goods_img" :src="item.image_list" @click="goDetail(item.id)">
							<div class="info">
								<p class="goods_name" @click="goDetail(item.id)">{{item.item_name}}</p>
								<p class="goods_price">
									<span class="price_Cur">
										<span class="currency_Unit">￥</span>
										<span class="txt">{{item.item_price}}</span>
									</span>
									<del class="price_Ori">
										<span class="currency_Unit">￥</span>
										<span class="txt">{{item.item_original_price}}</span>
									</del>
								</p>
								<!-- <p class="addCar"> -->
									<!-- <i class="el-icon-shopping-cart-full"></i> -->
									<!-- <span>加入购物车</span> -->
									<!-- <span>去购买</span>
								</p> -->
							</div>
						</div>
						<template slot="next"><span class="next"><i class="el-icon-arrow-right"></i></span></template>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
	</div>
</template>

<script>
	import bus from '../../assets/bus.js';
	import goBanner from './goBanner.js'
	import carousel from '../../plug/Carousel.vue'
	import { make_GoodsData_Processed } from './Util/Util_Goods_Item.js'
	export default {
		mixins: [
			goBanner
		],
		props:{
			componentType:{
				type:String,
				default:""
			},
			componentId:{
				type:String,
				default:""
			}
		},
		components: {
			carousel
		},
		data() {
			return {
				title:'',
				bannerImg:"",
				items:5,
				isMore: '',
				showTitle: '',
				
				// 
				page: 1,
				
				// 
				relevance_type: '',
				relevance_id: '',
				goodsData:[],
				pageNum: 8,
				goodsData_Processed: []
			}
		},
		created(){
			this.getData()
			.then(async goodsData => {
				if(goodsData && goodsData.length) {
					return await this.getData()
				}
			})
			.then(async goodsData => {
				if(goodsData && goodsData.length) {
					return await this.getData()
				}
			})
		},
		mounted() {
			this.onSize()
		},
		methods: {
			hdlCarousel_Change(i_New, i_Prev) {
				const i_Next = i_New + 1
				if(i_Next + 1 > this.page) {
					this.page = i_Next
					this.getData()
				}
			},
			onSize(){
				var clientWidth = document.documentElement.clientWidth
				if(clientWidth<768){
					this.items=2
				}else if(clientWidth<992){
					this.items=3
				}else if(clientWidth<1200){
					this.items=4
				}
			},
			getData(){
				const url = "/index.php/AppInterface/IndexModule"+this.componentType+"/index"
				return this.$server.post(url, {
					id: this.componentId,
					page: this.page || '1',
				})
				.then(res => {
					switch (res.result) {
						case 1:
							this.title =  res.data.index_arr.name
							this.bannerImg = res.data.index_arr.img
							this.relevance_type = res.data.index_arr.relevance_type
							this.relevance_id = res.data.index_arr.relevance_id
							this.isMore = res.data.index_arr.config_json.more
							this.showTitle = res.data.index_arr.config_json.show_title
							
							
							proc_GoodsData: {
								const goodsData = res.data.index_arr.item_arr
								let len_GoodsData_Last = this.goodsData && this.goodsData.length || 0
								if(this.goodsData instanceof Array) {
									this.goodsData.push(...goodsData)
								}
								else {
									this.goodsData = goodsData
								}
								if(this.goodsData.length > len_GoodsData_Last) {
									
									setTimeout(() => {
										make_GoodsData_Processed({
											pageNum: this.pageNum,
											goodsData,
											goodsData_Processed: this.goodsData_Processed
										})
										this.$forceUpdate()
									}, .25 * 1000)
									return goodsData
								}
							}
							break;
						default:
							uni.showToast({
								icon: "none",
								title: res.data.msg
							});
							break;
					}
				})
			},
			goDetail(id){
				if(! id) {
					console.log('goProduct: id is not found!')
					return
				}
				bus.$emit('goProduct', {
					path:"/productDetail",
					query:{
						id:id
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.modularThree {
		margin: 0 auto;
		width: $container-MaxWidth;
		max-width: $container-MaxWidth;
		min-width: $container-MaxWidth;
		
		
		
		// // TODO: 临时处理，之后要把首页模块不能下一页的bug修好
		// .el-carousel__arrow {
		// 	display: none!important;
		// }
		
		
		.part {

			.title {
				position: relative;
				height: 60px;
				margin-bottom: 25px;
				// border-bottom: 1px solid #f2f2f2;
				// font-size: 24px;
				
				.span {
					display: block;
					padding-bottom: 4px;
					// border-bottom: 2px solid $defaultColor;
					font-size: 20px;
					line-height: 60px;
					font-weight: bold;
					text-align: center;
					
					&:before,
					&:after
					{
						content: '———';
						margin: 0 6px;
					}
				}
				.more {
					position: absolute;
					right: 0;
					top: 0;
					height: 60px;
					color: #666;
					font-size: 14px;
					line-height: 60px;
					cursor: pointer;
					
					&:hover {
						text-decoration: underline;
					}
				}
			}
			// @media (max-width: 768px){
			// 	.title{
			// 		padding: 0 10px;
			// 		font-size: 16px;
			// 	}
			// }
			.bannerImg{
				display: block;
				width: 100%;
			}
			
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/modular/modular_three.vue